import React, { type ChangeEventHandler, type FC } from "react";

export type SliderProps = {
  label?: string;
  name: string;
  datalist?: Array<any>;
  min?: number;
  max?: number;
  value?: number;
  onChange?: ChangeEventHandler<HTMLInputElement>;
};

export const Slider: FC<SliderProps> = ({
  label,
  name,
  min,
  max,
  datalist,
  value,
  onChange,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <label className="block text-sm font-medium leading-6 text-gray-600">
        {label}
      </label>
      <input
        name={name}
        type="range"
        list={`${name}-datalist`}
        step="1"
        value={value}
        min={min}
        max={max}
        onChange={onChange}
      />
      {datalist != undefined && (
        <datalist id={`${name}-datalist`}>
          {new Array(max).fill(undefined).map((_, index) => (
            <option
              value={datalist[index + 1]?.value}
              label={datalist[index + 1]?.label}
            ></option>
          ))}
        </datalist>
      )}
    </div>
  );
};
